const PRODUCTS = [
  {
    id: "cat-fot",
    slug: "full-open-top-containers",
    name: "Full Open Top Containers",
    category: "Full Open Top Containers",
    featured: true,
    tagline: "Full-diameter access drums for pastes, powders and solids.",
    description: "Full Open Top HDPE drums with removable lids and steel locking rings. Blow-moulded from high-quality HDPE for chemicals, paints, adhesives, food pastes, pickles and hazardous solids. Every drum is custom-made to order — different weights and colours available.",
    material: "100% Virgin HDPE",
    sizes: ["35 L", "55 L", "65 L"],
    moq: "On request",
    image: "/products/fot-55-blue-closed.png",
    images: {
      "35 L": ["/products/fot-35-blue.png", "/products/fot-35-yellow.png"],
      "55 L": [
        "/products/fot-55-blue-closed.png",
        "/products/fot-55-blue-open.png",
        "/products/fot-55-yellow-closed.png",
        "/products/fot-55-yellow-open.png",
        "/products/fot-55-white-closed.png",
        "/products/fot-55-white-open.png",
      ],
      "65 L": ["/products/fot-65-blue.png"],
    },
  },
  {
    id: "cat-nm",
    slug: "narrow-mouth-containers",
    name: "Narrow Mouth Containers",
    category: "Narrow Mouth Containers",
    featured: true,
    tagline: "The stackable industry standard for liquids.",
    description: "Narrow Mouth HDPE mauser containers with secure screw caps — trusted for agro-chemicals, solvents, edible oils, lubricants and liquid detergents. Uniform footprint for pallet optimisation and leak-proof closure for safe liquid logistics. Custom-made in different weights and colours.",
    material: "100% Virgin HDPE",
    sizes: ["20 L", "25 L", "30 L", "35 L"],
    moq: "On request",
    image: "/products/nm-20-front.png",
    images: {
      "20 L": ["/products/nm-20-front.png", "/products/nm-20-side.png"],
      "25 L": ["/products/nm-25-front.png", "/products/nm-25-side.png"],
      "30 L": ["/products/nm-30-front.png"],
      "35 L": ["/products/nm-35-front.png", "/products/nm-35-side.png"],
    },
  },
  {
    id: "cat-rocket",
    slug: "narrow-mouth-rocket-container",
    name: "Narrow Mouth Rocket Container",
    category: "Narrow Mouth Rocket Container",
    featured: false,
    tagline: "Tall 55 L rocket-profile container.",
    description: "55 L HDPE Rocket Container with narrow mouth — a tall, space-saving profile for high-volume liquids like chemicals, water and industrial fluids, with a secure narrow-mouth cap. Custom-made in different weights and colours.",
    material: "100% Virgin HDPE",
    sizes: ["55 L"],
    moq: "On request",
    image: "/products/rocket-front.png",
    images: {
      "55 L": ["/products/rocket-front.png", "/products/rocket-side.png"],
    },
  },
  {
    id: "cat-round",
    slug: "center-mouth-round-container",
    name: "Center Mouth Round Container",
    category: "Center Mouth Round Container",
    featured: false,
    tagline: "Heavy-duty round drums with center mouth.",
    description: "Center Mouth Round HDPE containers with integrated handles — blow-moulded from high-molecular HDPE for chemicals, food ingredients and bulk storage. Heavy-duty body engineered for stacking strength in warehouses and transport. Custom-made in different weights and colours.",
    material: "100% Virgin HDPE",
    sizes: ["25 L", "50 L"],
    moq: "On request",
    image: "/products/round-lineup.jpg",
    lineup: true,
    images: {
      "25 L": ["/products/round-lineup.jpg", "/products/round-top.jpg"],
      "50 L": ["/products/round-lineup.jpg", "/products/round-top.jpg"],
    },
  },
  {
    id: "cat-jars",
    slug: "hdpe-jars-small-containers",
    name: "HDPE Jars & Small Containers",
    category: "HDPE Jars & Small Containers",
    featured: true,
    tagline: "Wide-mouth jars for food, FMCG and pharma.",
    description: "Food-grade HDPE wide-mouth jars and small containers with screw caps and optional induction sealing — made for ghee, honey, pickles, powders, spices, nutraceuticals and dry fruits. Custom-made in different weights and colours.",
    material: "100% Virgin Food-grade HDPE",
    sizes: ["250 GM", "500 GM", "1 KG", "5 KG"],
    moq: "On request",
    image: "/products/jars-lineup-blue.jpg",
    lineup: true,
    images: {
      "250 GM": ["/products/jars-lineup-blue.jpg", "/products/jars-lineup-white.jpg"],
      "500 GM": ["/products/jars-lineup-blue.jpg", "/products/jars-lineup-white.jpg"],
      "1 KG": ["/products/jars-lineup-blue.jpg", "/products/jars-lineup-white.jpg"],
      "5 KG": ["/products/jars-lineup-blue.jpg", "/products/jars-lineup-white.jpg"],
    },
  },
  {
    id: "cat-bottles",
    slug: "hdpe-bottles",
    name: "HDPE Bottles",
    category: "HDPE Bottles",
    featured: true,
    tagline: "Food-grade bottles for liquids and formulations.",
    description: "Food-grade HDPE bottles manufactured from virgin resin with consistent wall thickness and leak-proof closures. Suited for pharma syrups, edible oils, sauces, dairy products, chemicals and cleaning liquids. Custom-made in different weights and colours.",
    material: "100% Virgin Food-grade HDPE",
    sizes: ["100 ML", "250 ML", "500 ML", "1 L"],
    moq: "On request",
    image: "/products/bottles-lineup.jpg",
    lineup: true,
    images: {
      "100 ML": ["/products/bottles-lineup.jpg"],
      "250 ML": ["/products/bottles-lineup.jpg"],
      "500 ML": ["/products/bottles-lineup.jpg"],
      "1 L": ["/products/bottles-lineup.jpg", "/products/bottle-1l-yellow.png", "/products/bottle-1l-red.png"],
    },
  },
];

export default PRODUCTS;
